function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "noun_select_1751205",
  transform: "translate(150 87)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_641",
  "data-name": "Group 641",
  transform: "translate(-150 -87)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_351",
  "data-name": "Path 351",
  d: "M9.879,14.535,7.757,12.414a1,1,0,0,0-1.414,1.414l2.828,2.829a1,1,0,0,0,1.414,0l7.071-7.071a1,1,0,0,0-1.414-1.414ZM12,24A12,12,0,1,1,24,12,12,12,0,0,1,12,24Z"
})));

function SvgCompletedFilled2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "green",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedFilled2);
export default __webpack_public_path__ + "static/media/completed_filled_2.f684f3e9.svg";
export { ForwardRef as ReactComponent };